// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202602041557/js/" + chunkId + "." + {"44":"8b455d47","225":"5a0f746c","481":"6b61b3b2","486":"9dca0b75","770":"daf8f730"}[chunkId] + ".0.12145667794697435.chunk.js";
};